import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import API_BASE_URL from "../apiConfig";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";


const AdminMenu = () => {
  const navigate = useNavigate();
  const [lideres, setLideres] = useState([]);
  const [showModalLideres, setShowModalLideres] = useState(false);
  const [showParticipantesModal, setShowParticipantesModal] = useState(false);
  const [participantes, setParticipantes] = useState([]);
  const [currentLider, setCurrentLider] = useState(null);
  const [paginaActual, setPaginaActual] = useState(1);
  const lideresPorPagina = 3;
  const participantesPorPagina = 3;
  const [imagenSeleccionada, setImagenSeleccionada] = useState(null); // Estado para la imagen de INE
  const [activeIndex, setActiveIndex] = useState([]);
  // Coloca esto dentro de tu componente
  const [participantesMostrados, setParticipantesMostrados] = useState([]);

  const verImagenINE = (imagenUrl) => {
    setImagenSeleccionada(imagenUrl);
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Obtener todos los líderes
  const fetchLideres = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/Lider/ListarLideres`);
      console.log("Líderes recibidos:", response.data);
      setLideres(response.data);
      setShowModalLideres(true);
      setPaginaActual(1);
    } catch (error) {
      console.error("Error al obtener líderes:", );
      alert("El líder no tiene participantes.");
    }
  };

   // ACORDION
   const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const handleLogout = () => {
    localStorage.removeItem("adminUsuario");
    localStorage.removeItem("adminNombre");
    navigate("/AdminLogin"); //  Redirigir al login del admin
  };

  // **Paginación**
  const totalPaginas = Math.ceil(lideres.length / lideresPorPagina);
  const inicioIndex = (paginaActual - 1) * lideresPorPagina;
  const lideresMostrados = lideres.slice(inicioIndex, inicioIndex + lideresPorPagina);

///////////////////////////////////////////////////////////////////////////////////////////////////////////////

useEffect(() => {
  // Cálculo de participantes mostrados basado en la paginación actual
  const finIndex = paginaActual * participantesPorPagina;
  const inicioIndex = finIndex - participantesPorPagina;
  setParticipantesMostrados(participantes.slice(inicioIndex, finIndex));
}, [paginaActual, participantes, participantesPorPagina]);

const fetchParticipantes = async (usuario) => {
  if (!usuario) {
    alert("No se pudo obtener el usuario del líder.");
    return;
  }
  try {
    const response = await axios.get(`${API_BASE_URL}/Lider/GetParticipantes`, {
      params: { usuario },
    });

    console.log("Datos de participantes recibidos:", response.data);

    if (!response.data || response.data.length === 0) {
      Swal.fire({
        title: "Sin participantes",
        text: `El líder ${usuario} no tiene participantes registrados.`,
        icon: "warning",
        confirmButtonColor: "#0ea5e9",
        background: "#1e293b",
        color: "#ffffff",
      });
      return;
    }

    const participantesConINE = await Promise.all(
      response.data.map(async (p) => {
        try {
          const ineResponse = await axios.get(`${API_BASE_URL}/Lider/ObtenerINE`, {
            params: { telefono: p.whatsApp },
          });
          return { ...p, ineImagen: ineResponse.data.ineUrl };
        } catch (error) {
          console.warn(`No hay imagen de INE para: ${p.nombres}`);
          return { ...p, ineImagen: null };
        }
      })
    );

    console.log("Participantes con INE:", participantesConINE);
    setParticipantes(participantesConINE);
    setCurrentLider(usuario);
    setPaginaActual(1); // Resetear la página actual cada vez que se cargan nuevos participantes
    setShowParticipantesModal(true);
  } catch (error) {
    console.error("Error al obtener participantes:");
    Swal.fire({
      title: "",
      text: "El líder no tiene participnates.",
      icon: "error",
      confirmButtonColor: "#d33",
      background: "#1e293b",
      color: "#ffffff",
    });
  }
};


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const handleEliminarParticipante = async (telefono) => {
  const confirmacion = await Swal.fire({
    //title: '¿Estás seguro?',
    title: "¿Estás seguro de que deseas eliminar este participante?",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar',
    background: '#081b29', // Color de fondo oscuro
    color: '#ffffff', // Color del texto blanco para mayor contraste
  });

  if (!confirmacion.isConfirmed) return;

  try {
    const response = await axios.post(
      `${API_BASE_URL}/Lider/EliminarParticipante`,
      { telefono }, // ENVÍA EL TELÉFONO EN FORMATO JSON
      { headers: { "Content-Type": "application/json" } }
    );

    // Mostrar un mensaje de éxito
    Swal.fire({
      title: 'Eliminado!',
      text: response.data.message,
      icon: 'success',
      confirmButtonColor: '#3085d6',
      background: '#081b29', // Color de fondo oscuro
      color: '#ffffff' // Color del texto blanco
    });

    // ACTUALIZAR LA LISTA DE PARTICIPANTES DESPUÉS DE ELIMINAR
    setParticipantes((prevParticipantes) => prevParticipantes.filter((p) => p.whatsApp !== telefono));
  } catch (error) {
    console.error("Error al eliminar participante:", error);

    // Si hay un error del servidor, mostrarlo
    Swal.fire({
      title: 'Error!',
      text: `Error: ${error.response ? error.response.data.message : "No se pudo eliminar el participante"}`,
      icon: 'error',
      confirmButtonColor: '#d33',
      background: '#081b29', // Color de fondo oscuro
      color: '#ffffff' // Color del texto blanco
    });
  }
};


{/*
  const handleEliminarParticipante = async (telefono) => {
    const confirmacion = await Swal.fire({
      //title: '¿Estás seguro?',
      title: "¿Estás seguro de que deseas eliminar este participante?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
      background: '#081b29', // Color de fondo oscuro
      color: '#ffffff', // Color del texto blanco para mayor contraste
    });

    if (!confirmacion) return;

    try {
      const response = await axios.post(
        `${API_BASE_URL}/Lider/EliminarParticipante`,
        { telefono }, //  ENVÍA EL TELEFONO EN FORMATO JSON
        { headers: { "Content-Type": "application/json" } }
      );

      // Mostrar un mensaje de éxito
    Swal.fire({
      title: 'Eliminado!',
      text: response.data.message,
      icon: 'success',
      confirmButtonColor: '#3085d6',
      background: '#081b29', // Color de fondo oscuro
      color: '#ffffff' // Color del texto blanco
    });

      //  ACTUALIZAR LA LISTA DE PARTICIPANTES DESPUÉS DE ELIMINAR
      setParticipantes((prevParticipantes) => prevParticipantes.filter((p) => p.whatsApp !== telefono));
    } catch (error) {
      console.error("Error al eliminar participante:", error);

      //  SI HAY UN ERROR DEL SERVIDOR, MOSTRARLO
      if (error.response) {
        alert(`Error: ${error.response.data.message || "No se pudo eliminar el participante"}`);
      } else {
        alert("Hubo un error al eliminar el participante.");
      }
    }
  };
*/}
  const handleReenviarCredenciales = async (id, telefono) => {
    const resultado = await Swal.fire({
      title: "¿Reenviar credenciales?",
      text: `¿Seguro que deseas reenviar las credenciales al líder con teléfono ${telefono}?`,
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#0ea5e9", // Azul brillante
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, reenviar",
      cancelButtonText: "Cancelar",
      background: "#1e293b", // Fondo oscuro
      color: "#ffffff", // Texto en blanco
    });

    if (!resultado.isConfirmed) {
      return;
    }

    try {
      const response = await axios.post(
        `${API_BASE_URL}/Lider/ReenviarCredenciales?id=${id}`
      );

      Swal.fire({
        title: "Enviado",
        text: response.data.message,
        icon: "success",
        confirmButtonColor: "#0ea5e9",
        background: "#1e293b",
        color: "#ffffff",
      });

    } catch (error) {
      console.error("Error al reenviar credenciales:", error);

      Swal.fire({
        title: "Error",
        text: "Hubo un error al reenviar las credenciales.",
        icon: "error",
        confirmButtonColor: "#d33",
        background: "#1e293b",
        color: "#ffffff",
      });
    }
  };


 {/*
  const handleReenviarCredenciales = async (id, telefono) => {
    if (!window.confirm(`¿Seguro que deseas reenviar las credenciales al líder con teléfono ${telefono}?`)) {
      return;
    }
    try {
      const response = await axios.post(
        `${API_BASE_URL}/Lider/ReenviarCredenciales?id=${id}`
      );
      alert(response.data.message);
    } catch (error) {
      console.error("Error al reenviar credenciales:", error);
      alert("Hubo un error al reenviar las credenciales.");
    }
  };

  // ✅ Eliminar Líder
  {/*
  const handleEliminarLider = async (id, nombre) => {
    if (!window.confirm(`¿Seguro que deseas eliminar al líder ${nombre}? Esta acción eliminara a todos los participantes de este lider.`)) {
      return;
    }
    try {
      const response = await axios.post(`${API_BASE_URL}/Lider/EliminarLider?id=${id}`);
      alert(response.data.message);
      setLideres(lideres.filter((l) => l.id !== id));
    } catch (error) {
      console.error("Error al eliminar líder:", error);
      alert("Hubo un error al eliminar el líder.");
    }
  };
  */}
  const handleEliminarLider = async (id, nombre) => {
    const resultado = await Swal.fire({
      title: "¿Estás seguro?",
      text: `¿Seguro que deseas eliminar al líder ${nombre}? Esta acción eliminará a todos los participantes de este líder.`,
      //icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
      background: "#081b29", // Cambia el color de fondo (ejemplo: azul oscuro)
      color: "#ffffff", // Cambia el color del texto a blanco
    });

    if (!resultado.isConfirmed) {
      return;
    }

    try {
      const response = await axios.post(`${API_BASE_URL}/Lider/EliminarLider?id=${id}`);

      Swal.fire({
        title: "Eliminado",
        text: response.data.message,
        icon: "success",
        background: "#081b29", // Cambia el color de fondo (ejemplo: azul oscuro)
        color: "#ffffff", // Cambia el color del texto a blanco
        confirmButtonColor: "#3085d6",
      });

      setLideres((prevLideres) => prevLideres.filter((l) => l.id !== id));
    } catch (error) {
      console.error("Error al eliminar líder:", error);

      Swal.fire({
        title: "Error",
        text: "Hubo un error al eliminar el líder.",
        icon: "error",
        confirmButtonColor: "#d33",
      });
    }
  };

  return (
    <div className="wrapper">
      <div className="form-box">
        <img src="/img/monytorlogoa.png" alt="Imagen de login" className="login-image" />
        <h2>Menú de Administrador</h2>
        <div className="flex flex-col gap-3">

        <div className="">
            <button
              className="w-full text-center p-3 btn transition"
              onClick={() => toggleAccordion(1)}
            >
              Líder
            </button>
            {activeIndex === 1 && (
              <div className="p-3 bg-gray-700">
                <button className="block w-full text-left py-2 hover:bg-gray-600 transition" onClick={() => navigate("/autocreate")}>Registrar Líder</button>
                <button className="block w-full text-left py-2 hover:bg-gray-600 transition"  onClick={fetchLideres}>Ver Líderes</button>
                <button className="block w-full text-left py-2 hover:bg-gray-600 transition" onClick={() => navigate("/AdminLideres")}>Gestor de Líderes</button>
                <button className="block w-full text-left py-2 hover:bg-gray-600 transition" onClick={() => navigate("/AdminParticipantes")}>Gestor de Participantes</button>
              </div>
            )}
          </div>

          <div className=" ">
            <button
              className="w-full text-center p-3 btn transition"
              onClick={() => toggleAccordion(2)}
            >
              Eventos
            </button>
            {activeIndex === 2 && (
              <div className="p-3 bg-gray-700">
                <button className="block w-full text-left py-2 hover:bg-gray-600 transition" onClick={() => navigate("/adminEventos")}>Eventos</button>
                <button className="block w-full text-left py-2 hover:bg-gray-600 transition" onClick={() => navigate("/ConsultaEventosMasivos")}>Consultar Eventos Masivos</button>
              </div>
            )}
          </div>

          <div className=" ">
            <button
              className="w-full text-center p-3 btn transition"
              onClick={() => toggleAccordion(3)}
            >
              Resultados
            </button>
            {activeIndex === 3 && (
              <div className="p-3 bg-gray-700">
                <button className="block w-full text-left py-2 hover:bg-gray-600 transition" onClick={() => navigate("/adminAuditoria")}>Eventos Auditados</button>
                <button className="block w-full text-left py-2 hover:bg-gray-600 transition" onClick={() => navigate("/estructuraNiveles")}>Estructura por Niveles</button>
                <button className="block w-full text-left py-2 hover:bg-gray-600 transition" onClick={() => navigate("/AdminNiveles")}>Niveles</button>
              </div>
            )}
          </div>

          <button className="btn btn-danger" onClick={handleLogout}>
            Cerrar Sesión
          </button>
        </div>

        {/* ✅ MODAL DE LÍDERES CON PAGINACIÓN */}
        {showModalLideres && (
          <div
            className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
          >
            <div
              className="bg-[#081b29] p-6 rounded-lg shadow-lg max-w-lg w-full relative text-white max-h-screen overflow-y-auto"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex justify-between items-center border-b pb-2">
                <h3 className="text-lg font-semibold flex items-center">
                  <img src="/img/logoazul.png" alt="Icono" className="w-6 h-6 mr-2" />
                  Lista de Líderes
                </h3>
                <h4 className="text-lg font-semibold text-white">
                  Total de Líderes: {lideres.length}
                </h4>
                <button onClick={() => setShowModalLideres(false)} className="text-red-600 hover:text-red-800 text-lg">
                  ✖
                </button>
              </div>

              {/*  Lista de Líderes con botones */}
              <div className="mt-4">
                {lideres.length > 0 ? (
                  <>
                    <ul className="list-none pl-0 space-y-4">
                      {lideresMostrados.map((lider, index) => (
                        <li key={index} className="flex flex-col border-b pb-2">
                          <div className="mb-2">
                            <strong>{lider.nombre || "Sin nombre"}</strong> <br />
                            <small>Usuario: {lider.usuario || "No tiene usuario"}</small> <br />
                            <small>Teléfono: {lider.telefono || "No tiene teléfono"}</small> <br />
                            <small>Nivel: {lider.nivelId || "No tiene nivel"}</small> <br />
                            <small>Registrado el: {lider.fechaRegistro || "Fecha desconocida"}</small>
                          </div>
                          <div className="flex gap-2">
                            <button
                              className="bg-blue-500 text-black px-3 py-1 rounded hover:bg-blue-600 transition"
                              onClick={() => fetchParticipantes(lider.usuario)}
                            >
                              Ver Participantes
                            </button>
                            <button
                              className="bg-green-500 text-black px-3 py-1 rounded hover:bg-green-600 transition"
                              onClick={() => handleReenviarCredenciales(lider.id, lider.telefono)}
                            >
                              Reenviar Accesos
                            </button>
                            <button
                              className="bg-red-500 text-black px-3 py-1 rounded hover:bg-red-600 transition"
                              onClick={() => handleEliminarLider(lider.id, lider.nombre)}
                            >
                              Eliminar
                            </button>
                          </div>
                        </li>
                      ))}
                    </ul>

                    {/* 🔹 Paginación */}
                    <div className="flex justify-center mt-4 gap-2">
                      <button disabled={paginaActual === 1} onClick={() => setPaginaActual(paginaActual - 1)}>
                        ◀ Anterior
                      </button>
                      {[...Array(totalPaginas)].map((_, index) => (
                        <button key={index} onClick={() => setPaginaActual(index + 1)}>
                          {index + 1}
                        </button>
                      ))}
                      <button disabled={paginaActual === totalPaginas} onClick={() => setPaginaActual(paginaActual + 1)}>
                        Siguiente ▶
                      </button>
                    </div>
                  </>
                ) : (
                  <p className="text-gray-600 text-center">No hay líderes registrados.</p>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Modal de Participantes */}
         {/* CON PAGINACIÓN */}

         {showParticipantesModal && (
      <div
        className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 p-4"
        //onClick={() => setShowParticipantesModal(false)}
      >
        <div
          className="bg-[#081b29] p-6 rounded-lg shadow-lg max-w-[95vw] md:max-w-lg w-full relative text-white max-h-screen overflow-y-auto"
          onClick={(e) => e.stopPropagation()}
        >
          {/*  ENCABEZADO DEL MODAL */}
          <div className="flex justify-between items-center border-b pb-2">
            <h3 className="text-lg font-semibold flex items-center">
              <img src="/img/logoazul.png" alt="Icono" className="w-6 h-6 mr-2" />
              Lista de Participantes
              </h3>
              <h4 className="text-lg font-semibold text-white">
                        Total: {participantes.length}
                      </h4>
            <button
              onClick={() => setShowParticipantesModal(false)}
              className="text-red-600 hover:text-red-800 text-lg"
            >
              ✖
            </button>
          </div>

        {/*  PAGINACIÓN DE PARTICIPANTES */}
              <div className="mt-4">
                {participantes.length > 0 ? (
                  <>

                    <ul className="list-none pl-0 space-y-3">
                      {participantes
                        .slice((paginaActual - 1) * 4, paginaActual * 4)
                        .map((p, index) => (
                          <li key={index} className="flex flex-col sm:flex-row justify-between items-center border-b pb-2 text-xs sm:text-sm md:text-base">
                            <div className="text-center sm:text-left">
                              <strong>{p.nombres} {p.apellidos}</strong> <br />
                              <span className="text-gray-300">📞 {p.whatsApp}</span> <br />
                              <small className="text-gray-400">🗓 Registrado el: {p.fechaRegistro}</small>
                            </div>

                            {/*  Botones de acciones */}
                            <div className="flex flex-col sm:flex-row gap-2 mt-2 sm:mt-0">
                              {p.ineImagen && (
                                <button
                                  className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600 transition text-xs sm:text-sm"
                                  onClick={() => verImagenINE(p.ineImagen)}
                                >
                                  Ver INE
                                </button>
                              )}
                              <button
                                className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600 transition text-xs sm:text-sm"
                                onClick={() => handleEliminarParticipante(p.whatsApp)}
                              >
                                Eliminar
                              </button>
                            </div>
                          </li>
                        ))}
                    </ul>

                    {/*  Paginación */}
                    <div className="flex justify-center mt-4 gap-2">
                      <button
                        className={`px-3 py-1 rounded ${
                          paginaActual === 1 ? "bg-gray-500 cursor-not-allowed" : "bg-blue-500 hover:bg-blue-600"
                        }`}
                        onClick={() => setPaginaActual(paginaActual - 1)}
                        disabled={paginaActual === 1}
                      >
                        ◀ Anterior
                      </button>

                      {[...Array(Math.ceil(participantes.length / 4))].map((_, index) => (
                        <button
                          key={index}
                          className={`px-3 py-1 rounded ${
                            paginaActual === index + 1 ? "bg-white text-black font-bold" : "bg-gray-500 hover:bg-gray-600"
                          }`}
                          onClick={() => setPaginaActual(index + 1)}
                        >
                          {index + 1}
                        </button>
                      ))}

                      <button
                        className={`px-3 py-1 rounded ${
                          paginaActual === Math.ceil(participantes.length / 4) ? "bg-gray-500 cursor-not-allowed" : "bg-blue-500 hover:bg-blue-600"
                        }`}
                        onClick={() => setPaginaActual(paginaActual + 1)}
                        disabled={paginaActual === Math.ceil(participantes.length / 4)}
                      >
                        Siguiente ▶
                      </button>
                    </div>
                  </>
                ) : (
                  <p className="text-gray-300 text-center">No hay participantes registrados.</p>
                )}

                {/* MODAL PARA VER IMAGEN DE IN*/}
                {imagenSeleccionada && (
                  <div
                    className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75"
                    onClick={() => setImagenSeleccionada(null)}
                  >
                    <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full text-black relative"
                        onClick={(e) => e.stopPropagation()}>
                      <div className="flex justify-between items-center border-b pb-2">
                        <h3 className="text-lg font-semibold">Imagen de INE</h3>
                        <button
                          onClick={() => setImagenSeleccionada(null)}
                          className="text-gray-600 hover:text-black text-lg"
                        >
                          ✖
                        </button>
                      </div>
                      <div className="mt-4 flex justify-center">
                        <img src={imagenSeleccionada} alt="INE" className="max-w-full h-auto rounded-lg" />
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/*  BOTÓN PARA CERRAR EL MODAL */}
              <div className="mt-6 flex justify-center sm:justify-end gap-2">
                <button
                  className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 transition text-xs sm:text-sm md:text-base"
                  onClick={() => setShowParticipantesModal(false)}
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminMenu;




















